export const experienceData={
    from: "July/2012",
    to: "Mar/2013",
    company: "Resumo Ltd",
    position: "Software Engineer",
    place: "Berlin,Germany",
    jobDescription: `This is a job description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free. Our main domain is resumo.in. We developed this site with React and in backend we used nodejs.Please replace this part and write your own description.`
}

export const projectData={
    name: "Project Name",
    desc: `This is a project description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free.`
}

export const educationData={
    course: "BTech",
    time: "July/2014 to July/2018",
    desc: `This is a project description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free.`
}

export const certificateData={
    name: "Web Developer Bootcamp",
    provider: "Provided by Resumo"
}

export const aboutData={
    platform: "Platform",
    link: "https://www.linkedin.com/in/"
}

export const initialStateData={

    name: "John",
    surname: "Doe",
    position: "Software Engineer",
    email:"john.doe@email.com",
    aboutMe:`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry
    standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make
    a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,
    remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing
    Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions
    of Lorem Ipsum`,
    imageData:"https://www.w3schools.com/howto/img_avatar.png",
    font:"https://fonts.googleapis.com/css?family=Jura:300,70",
    fontSize:"14px",
    fontName:'Jura',
    color: "rebeccapurple",
    skills: ["React", "Redux", "Java Script", "Demo"],
    interests: ["Dance", "Running", "Watching Movies", "Coding"],
    proLanguages: ["JS", "Java", "Kotlin"],
    spolanguages: ["English", "Hindi", "Gujarati"],
    otherSkills: ["Jira", "XP"],
    address: {
        area: 'RemotePlace 3',
        city: "Amsterdam",
        pin: "39000",
        country: "Netherland"
    },
    objective:"I want to learn and apply those learnings into some project where it can be useful. I want to grow togather with the company and provide my contribution in it.",
    experience: [
        {
            from: "July/2012",
            to: "Mar/2013",
            company: "Resumo GmBh",
            position: "Software Engineer",
            place: "Berlin,Germany",
            jobDescription: `This is a job description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free. Our main domain is resumo.in. We developed this site with React and in backend we used nodejs.Please replace this part and write your own description.`
        },
        {
            from: "July/2012",
            to: "Mar/2013",
            company: "Resumo GmBh",
            position: "Software Engineer",
            place: "Berlin,Germany",
            jobDescription: `This is a job description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free. Our main domain is resumo.in. We developed this site with React and in backend we used nodejs.Please replace this part and write your own description.`
        },
        {
            from: "July/2012",
            to: "Mar/2013",
            company: "Resumo GmBh",
            position: "Software Engineer",
            place: "Berlin,Germany",
            jobDescription: `This is a job description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free. Our main domain is resumo.in. We developed this site with React and in backend we used nodejs.Please replace this part and write your own description.`
        }
    ],
    education: [
        {
            course: "BTech",
            time: "July/2014 to July/2018",
            desc: `This is a education description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free.`
        },
        {
            course: "BTech",
            time: "July/2014 to July/2018",
            desc: `This is a education description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free.`
        }
    ],
    project: [
        {
            name: "Project Name",
            desc: `This is a project description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free.`
        },
        {
            name: "Project Name",
            desc: `This is a project description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free.`
        },
        {
            name: "Project Name",
            desc: `This is a project description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free.`
        },
        {
            name: "Project Name",
            desc: `This is a project description section and we recommend to use 250 characters so that it looks good and well detailed. Resumo is a resume builder platform provided to you for free.`
        }
    ],
    achievement: [
        "Found and report a Bug(XSS) in Snapdeal",
        "Bla Bla Bla",
        "Bla Bla Bla",
        "Created resumo a free resume builder.",

    ],
    certificate: [
        {
            name: "Web Developer Bootcamp",
            provider: "Provided by Resumo"
        },
        {
            name: "React JS Bootcamp",
            provider: "Provided by Resumo"
        }
    ],
    about: [
        {
            platform: "LinkedIn",
            link: "https://www.linkedin.com/in"
        },
        {
            platform: "Github",
            link: "https://www.linkedin.com/"
        },
        {
            platform: "Instagram",
            link: "https://www.linkedin.com/"
        },
        {
            platform: "Xing",
            link: "https://www.xing.com/profile/"
        }
    ]
}

export const privacyData={
    header:"Privacy Policy",
    text:"We are not storing any personal information that you feed to our site.However we use google analytics that just keep track of the users and load on the website. We want you to feel free and enjoy the 100% free services offered to you."
}

export const tou={
    header:"Terms Of Use",
    text:"We have the right to revoke our services at any time. This is a free service but in future we might become a paid service or start showing the ads in future.At any point you might fail to generate the resume due to the failure of our service or networkk we are not responsible.We reserve all the right. Do not try to use our code for production/personal use without notifying or taking permission from us. The frontend service is the only free service provided to you.To use other services like API or othre please contact us at parthmakadiya007@gmail.com"
}

export const fontMap={
    "Jura": "https://fonts.googleapis.com/css?family=Jura:300,700",
    "Jost": "https://fonts.googleapis.com/css2?family=Jost:wght@100;600&display=swap",
    "openSans": "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;800&display=swap",
    "Inconsolata": "https://fonts.googleapis.com/css2?family=Inconsolata:wght@200;800&display=swap"
}